import { CustomTemplateSectionType } from '../../../../../schemas/kpi-template.schema';
import { QuantitativeSectionEditor } from './QuantitativeSectionEditor';

interface SectionContentProps {
  sectionIndex: number;
  onCreateNewKpi?: (sectionIndex: number, sectionType: CustomTemplateSectionType, kpiName?: string) => void;
}

export function SectionContent({ sectionIndex, onCreateNewKpi }: SectionContentProps) {
  return <QuantitativeSectionEditor sectionIndex={sectionIndex} onCreateNewKpi={onCreateNewKpi} />;
}
